import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  query: {},
};

const smsSlice = createSlice({
  name: "smsManage",
  initialState,
  reducers: {
    setQueryValue: (state, action) => {
      if (action.payload.key) {
        state.query[action.payload.key] = action.payload.value;
      } else {
        state.query = action.payload;
      }
    },
  },
});

export const { setQueryValue } = smsSlice.actions;

export default smsSlice.reducer;
